/* Frequently Bought Together — bundle add-to-cart for the PDP companion widget.
   On checkbox change updates the live total. On click, submits the anchor
   product via its form (so it picks up free-name-customization properties
   and the selected variant), then calls /cart/add.js for each checked
   companion. Finally opens the cart drawer (or refreshes it if already open). */
(function () {
  'use strict';

  function moneyFormat(cents) {
    /* Use Shopify's locale-aware formatter when available, else fall back. */
    if (window.Shopify && window.Shopify.formatMoney) {
      return Shopify.formatMoney(cents, window.theme && theme.moneyFormat);
    }
    return 'EGP ' + (cents / 100).toLocaleString(undefined, {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    });
  }

  function init(root) {
    if (!root || root.dataset.fbtBound === '1') return;
    root.dataset.fbtBound = '1';

    var anchorPrice = parseInt(root.getAttribute('data-anchor-price'), 10) || 0;
    var totalEl = root.querySelector('[data-fbt-total]');
    var checks = Array.prototype.slice.call(root.querySelectorAll('[data-fbt-check]'));
    var addBtn = root.querySelector('[data-fbt-add]');
    var ctaDefault = root.querySelector('[data-fbt-cta-default]');
    var ctaLoading = root.querySelector('[data-fbt-cta-loading]');
    var errorEl = root.querySelector('[data-fbt-error]');

    function recalcTotal() {
      var total = anchorPrice;
      checks.forEach(function (cb) {
        if (cb.checked) {
          var price = parseInt(cb.getAttribute('data-price'), 10) || 0;
          total += price;
        }
      });
      if (totalEl) totalEl.textContent = moneyFormat(total);
    }

    checks.forEach(function (cb) {
      cb.addEventListener('change', recalcTotal);
    });
    recalcTotal();

    function setLoading(isLoading) {
      if (!addBtn) return;
      addBtn.disabled = isLoading;
      if (ctaDefault) ctaDefault.hidden = isLoading;
      if (ctaLoading) ctaLoading.hidden = !isLoading;
    }

    function showError(msg) {
      if (!errorEl) return;
      errorEl.textContent = msg;
      errorEl.hidden = false;
    }

    function clearError() {
      if (!errorEl) return;
      errorEl.textContent = '';
      errorEl.hidden = true;
    }

    function submitAnchor() {
      /* Find the on-page product form so the active variant + line-item
         properties (free name print, etc.) are carried with the anchor add. */
      var formId = addBtn && addBtn.getAttribute('data-anchor-form');
      var form = formId && document.getElementById(formId);
      if (!form) {
        form = document.querySelector('form[action*="/cart/add"]');
      }
      if (!form) {
        return Promise.reject(new Error('No product form found on page.'));
      }
      var formData = new FormData(form);
      var anchorQty = parseInt(formData.get('quantity') || '1', 10) || 1;
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: formData,
      }).then(function (res) {
        if (!res.ok) {
          return res.json().then(function (err) {
            throw new Error(err.description || err.message || 'Could not add main product.');
          });
        }
        return res.json().then(function (line) {
          /* Carry the form quantity through; Shopify's response reports the
             line's cumulative quantity, not what was added on this click. */
          if (line) line.__addedQty = anchorQty;
          return line;
        });
      });
    }

    function addCompanion(variantId) {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({ id: variantId, quantity: 1 }),
      }).then(function (res) {
        if (!res.ok) {
          return res.json().then(function (err) {
            throw new Error(err.description || err.message || 'Could not add a recommended item.');
          });
        }
        return res.json().then(function (line) {
          /* Companion adds are always quantity 1; pin it so the analytics
             event doesn't pick up the cumulative line count. */
          if (line) line.__addedQty = 1;
          return line;
        });
      });
    }

    if (addBtn) {
      addBtn.addEventListener('click', function () {
        clearError();
        setLoading(true);

        var checkedIds = checks
          .filter(function (cb) { return cb.checked; })
          .map(function (cb) { return parseInt(cb.getAttribute('data-variant-id'), 10); })
          .filter(function (id) { return !!id; });

        var addedLines = [];
        submitAnchor()
          .then(function (anchorLine) {
            if (anchorLine) addedLines.push(anchorLine);
            /* Add companions sequentially — keeps order predictable and
               avoids racing on Shopify's cart endpoints. */
            return checkedIds.reduce(function (chain, id) {
              return chain.then(function () {
                return addCompanion(id).then(function (line) {
                  if (line) addedLines.push(line);
                });
              });
            }, Promise.resolve());
          })
          .then(function () {
            // GA4 + Meta Pixel: one combined add-to-cart event for the bundle
            if (addedLines.length) {
              var items = addedLines.map(function (l) {
                return {
                  item_id: String(l.product_id || l.id),
                  item_name: l.product_title || l.title,
                  item_brand: l.vendor || undefined,
                  item_category: l.product_type || undefined,
                  item_variant: l.variant_title || undefined,
                  price: (l.price || 0) / 100,
                  quantity: l.__addedQty || 1
                };
              });
              var totalValue = items.reduce(function (s, i) { return s + i.price * i.quantity; }, 0);
              if (typeof window.gtag === 'function') {
                window.gtag('event', 'add_to_cart', {
                  currency: 'EGP',
                  value: totalValue,
                  items: items
                });
              }
              if (typeof window.fbq === 'function') {
                window.fbq('track', 'AddToCart', {
                  content_ids: items.map(function (i) { return i.item_id; }),
                  content_type: 'product',
                  content_name: items[0] && items[0].item_name,
                  currency: 'EGP',
                  value: totalValue
                });
              }
            }
            // Shared helper defined in cart-drawer.js — refreshes the drawer
            // (line items + header count + recs) then opens it.
            window.refreshCartDrawer();
          })
          .catch(function (err) {
            showError(err && err.message ? err.message : 'Something went wrong adding to cart.');
          })
          .finally(function () {
            setLoading(false);
          });
      });
    }
  }

  function boot() {
    document.querySelectorAll('[data-fbt]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
